import React from "react";
import logo from "../../img/logo.png";
const Header = () => {
  return (
    <header className="center">
      <img src={logo} alt="Alternative text" />
    </header>
  );
};

export default Header;
